import { Link } from 'react-router-dom';
import { MapPin, Phone, Instagram, MessageCircle, Clock } from 'lucide-react';
import { waLink } from '../lib/contact';

const WA_HELLO     = waLink('Hola Bar Cabrero!');
const WA_TAKEAWAY  = waLink('Hola Bar Cabrero! Querria encargar gildas para llevar. Gracias!');
const WA_CATERING  = waLink('Hola Bar Cabrero! Estoy organizando un evento y querria info sobre catering de gildas. Gracias!');

const YEAR = new Date().getFullYear();

export default function Footer() {
  return (
    <>
      <footer data-testid="footer">
        <div className="ft-brand">
          <Link to="/" className="ft-logo" aria-label="Bar Cabrero · Inicio">
            <span className="ft-logo-line1">Bar <em>Cabrero</em></span>
            <small>Est. 1928 · Torrelavega · Cantabria</small>
          </Link>
          <p className="ft-tag">
            &ldquo;Gildas artesanas, tortilla casera y la barra más alta de la ciudad. Casi un siglo en pie.&rdquo;
          </p>
          <div className="ft-social" aria-label="Redes sociales">
            <a href="https://instagram.com/cabrerobar" target="_blank" rel="noopener noreferrer" aria-label="Instagram @cabrerobar"><Instagram size={16} /></a>
            <a href={WA_HELLO} target="_blank" rel="noopener noreferrer" aria-label="WhatsApp"><MessageCircle size={16} /></a>
            <a href="tel:+34654233407" aria-label="Llamar"><Phone size={16} /></a>
          </div>
        </div>

        <nav className="fc" aria-label="Carta">
          <h4>La Carta</h4>
          <Link to="/gildas">Las 12 Gildas</Link>
          <Link to="/gildas#quiz">Descubre tu Gilda</Link>
          <Link to="/tortilla">Tortilla casera</Link>
          <Link to="/bebidas">Vinos y vermut</Link>
          <Link to="/galeria">Galería</Link>
        </nav>

        <nav className="fc" aria-label="El Bar">
          <h4>El Bar</h4>
          <Link to="/historia">Nuestra historia</Link>
          <Link to="/visitanos">Cómo llegar</Link>
          <Link to="/visitanos#horario">Horarios</Link>
          <a href={WA_TAKEAWAY} target="_blank" rel="noopener noreferrer">Para llevar</a>
          <a href={WA_CATERING} target="_blank" rel="noopener noreferrer">Catering eventos</a>
          <a href="/dossier.pdf" download="Bar-Cabrero-Dossier.pdf" data-testid="footer-prensa">Dossier &amp; prensa (PDF)</a>
        </nav>

        <div className="fc">
          <h4>Encuéntranos</h4>
          <p className="ft-line"><MapPin size={13} /> C. Julián Ceballos 19</p>
          <p className="ft-line"><MapPin size={13} /> 39300 Torrelavega</p>
          <a href="tel:+34654233407" className="ft-line"><Phone size={13} /> +34 654 23 34 07</a>
          <a href="https://instagram.com/cabrerobar" target="_blank" rel="noopener noreferrer" className="ft-line"><Instagram size={13} /> @cabrerobar</a>
          <p className="ft-line ft-hours"><Clock size={13} /> Cerramos los martes</p>
        </div>
      </footer>

      <div className="ft-bottom">
        <p>© {YEAR} Bar Cabrero · Rumoroso56 S.L. · Torrelavega, Cantabria</p>
        <nav className="ft-legal" aria-label="Información legal">
          <Link to="/aviso-legal" data-testid="footer-aviso-legal">Aviso legal</Link>
          <span aria-hidden="true">·</span>
          <Link to="/politica-privacidad" data-testid="footer-politica-privacidad">Privacidad</Link>
          <span aria-hidden="true">·</span>
          <Link to="/politica-cookies" data-testid="footer-politica-cookies">Cookies</Link>
        </nav>
        <p className="ft-credit" data-testid="footer-credit">
          Diseño y desarrollo:{' '}
          <a href="https://eolasprints.com" target="_blank" rel="noopener noreferrer">
            Tanuj Goswami · Eolas Prints
          </a>
          <span aria-hidden="true"> · </span>
          <a href="tel:+34942735955">+34 942 73 59 55</a>
        </p>
      </div>
    </>
  );
}
